import React, { Fragment } from 'react';
interface SymbolProps {
  size?: number;
  className?: string;
}
export function GenogramDiagram({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-89" data-mp="10dgsjojs0gbi">
      <circle cx="30" cy="30" r="10" data-id="element-90" data-mp="qdpy1mv7u1bf" />
      <rect x="60" y="20" width="20" height="20" data-id="element-91" data-mp="qer9vtk22ru7" />
      <line x1="40" y1="30" x2="60" y2="30" data-id="element-92" data-mp="1o1860vh1yzed" />
      <line x1="50" y1="30" x2="50" y2="60" data-id="element-93" data-mp="1o05c0eofogu8" />
      <circle cx="50" cy="70" r="10" data-id="element-94" data-mp="1j1vlwihkg6fh" />
    </svg>;
}
export function ConnectedSilhouettes({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-95" data-mp="1e9ashi2knvch">
      {/* Figure 1 */}
      <circle cx="30" cy="30" r="8" data-id="element-96" data-mp="26qwmxko2kfaq" />
      <path d="M30 38 v25 M20 50 h20 M25 80 l5 -17 l5 17" data-id="element-97" data-mp="26ry7qguw0g5n" />
      {/* Figure 2 */}
      <circle cx="70" cy="40" r="8" data-id="element-98" data-mp="2207wm8o4lod6" />
      <path d="M70 48 v25 M60 60 h20 M65 90 l5 -17 l5 17" data-id="element-99" data-mp="21z511nfuyxqx" />
      {/* Connection */}
      <line x1="40" y1="50" x2="60" y2="60" strokeDasharray="2 2" data-id="element-100" data-mp="1rslg21v61lc8" />
    </svg>;
}
export function ConstellationNodeMap({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-101" data-mp="1i31wsv3jjpgu">
      <circle cx="20" cy="20" r="4" data-id="element-102" data-mp="1mzilbqenk5ug" />
      <circle cx="80" cy="30" r="4" data-id="element-103" data-mp="191lpwxbxq5hd" />
      <circle cx="50" cy="50" r="4" data-id="element-104" data-mp="190izsrmfs72i" />
      <circle cx="30" cy="80" r="4" data-id="element-105" data-mp="193onq3jbx2wn" />
      <circle cx="70" cy="70" r="4" data-id="element-106" data-mp="1d3p25o6fhe3p" />
      <line x1="24" y1="22" x2="46" y2="48" data-id="element-107" data-mp="1d4qm6i5f9axk" />
      <line x1="76" y1="32" x2="54" y2="48" data-id="element-108" data-mp="z3nyk0ys3skj" />
      <line x1="48" y1="54" x2="32" y2="76" data-id="element-109" data-mp="z4pk4zdf7xgi" />
      <line x1="54" y1="52" x2="68" y2="68" data-id="element-110" data-mp="142hgq6p0g7r1" />
    </svg>;
}
export function PegDollSymbol({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-111" data-mp="2tiqlbqwg0wjr">
      <circle cx="50" cy="25" r="15" data-id="element-112" data-mp="2yefn80vxqpj8" />
      <path d="M35 40 Q50 35 65 40 L75 90 Q50 95 25 90 Z" data-id="element-113" data-mp="2wzw5lspcxs52" />
    </svg>;
}
export function ConcentricRings({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-114" data-mp="2s2crqtwknhdn">
      <circle cx="50" cy="50" r="40" data-id="element-115" data-mp="2i2c5p07bin5r" />
      <circle cx="50" cy="50" r="30" data-id="element-116" data-mp="2i3dqvxi1sq17" />
      <circle cx="50" cy="50" r="20" data-id="element-117" data-mp="2i4gjqayxl2jr" />
      <circle cx="50" cy="50" r="10" data-id="element-118" data-mp="3fq44fym0xwfg" />
    </svg>;
}
export function FlowerOfLifeFragment({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-119" data-mp="3asui4rtxm0vu">
      <circle cx="50" cy="30" r="25" data-id="element-120" data-mp="3117x63rsknfw" />
      <circle cx="30" cy="60" r="25" data-id="element-121" data-mp="3106lbx2ybwx4" />
      <circle cx="70" cy="60" r="25" data-id="element-122" data-mp="30z3vlshd80is" />
    </svg>;
}
export function RelationalFlowArrow({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-123" data-mp="3tpdhipexoaf7">
      <circle cx="20" cy="80" r="5" data-id="element-124" data-mp="5ugg6ekleebl" />
      <circle cx="80" cy="20" r="5" data-id="element-125" data-mp="9ugzacimzdoz" />
      <path d="M25 75 Q40 40 75 25" markerEnd="url(#arrowhead)" data-id="element-126" data-mp="9vid2or1eeae" />
      <defs data-id="element-127" data-mp="ettmiydf6ms3">
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto" data-id="element-128" data-mp="et0n6igsizjz">
          <polygon points="0 0, 10 3.5, 0 7" fill="currentColor" data-id="element-129" data-mp="jswv2sslzb4t" />
        </marker>
      </defs>
    </svg>;
}
export function SystemicTriad({
  size = 30,
  className = ''
}: SymbolProps) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1" className={className} data-id="element-130" data-mp="sstb660xn1o9">
      <circle cx="50" cy="20" r="8" data-id="element-131" data-mp="xlcor2zmdwt2" />
      <circle cx="20" cy="80" r="8" data-id="element-132" data-mp="xme43jno55gl" />
      <circle cx="80" cy="80" r="8" data-id="element-133" data-mp="12jea5ukiq87p" />
      <line x1="46" y1="28" x2="24" y2="72" data-id="element-134" data-mp="12icutdwgyzk6" />
      <line x1="54" y1="28" x2="76" y2="72" data-id="element-135" data-mp="17ir6r716ytnh" />
      <line x1="28" y1="80" x2="72" y2="80" data-id="element-136" data-mp="17jsf33qtp21i" />
    </svg>;
}
export const ALL_CONSTELLATION_SYMBOLS = [GenogramDiagram, ConnectedSilhouettes, ConstellationNodeMap, PegDollSymbol, ConcentricRings, FlowerOfLifeFragment, RelationalFlowArrow, SystemicTriad];